import React, { AllHTMLAttributes } from 'react';
import classNames from 'classnames';
import { css } from '@emotion/react';
import { border_radius_styles_with_size } from '../../foundation';
import {
  input_default_style,
  input_error_style,
  input_disabled_style,
  getInputPaddingBySize,
  getInputHeightBySize,
  getInputFontStyle,
} from './styles';
import { InputSize, InputStatus } from './types';
import { buildCSSWithLength } from '../../styles';

export interface InputAddonOwnProps {
  disabled?: boolean;
  status?: InputStatus;
  /** @default 'left' */
  position: 'left' | 'right';
  /** @default 'medium' */
  size?: InputSize;
}

export type InputAddonProps = InputAddonOwnProps & Omit<AllHTMLAttributes<HTMLDivElement>, 'size'>;

export const InputAddon = React.forwardRef<HTMLDivElement, InputAddonProps>(
  ({ status, disabled, position = 'left', size = 'medium', ...props }, ref) => {
    const border_radius = border_radius_styles_with_size.small;
    const status_style = {
      ...input_default_style,
      ...(status && status === 'error' && input_error_style),
      ...(disabled && input_disabled_style),
    };

    const position_style = css`
      ${position === 'left'
        ? {
            'borderRight': 0,
            '&:focus, &:hover': {
              borderRight: 0,
            },
          }
        : {
            'borderLeft': 0,
            '&:focus, &:hover': {
              borderLeft: 0,
            },
          }}
    `;

    return (
      <div
        className={classNames('pds-input-addon', position)}
        css={[
          css`
            display: flex;
            align-items: center;
            flex: none;
            border-radius: ${position === 'left'
              ? `${border_radius}px 0 0 ${border_radius}px`
              : `0 ${border_radius}px ${border_radius}px 0`};
            padding: ${getInputPaddingBySize(size)};
            ${buildCSSWithLength('height', getInputHeightBySize(size))}
          `,
          status_style,
          position_style,
          getInputFontStyle(size),
        ]}
        ref={ref}
        {...props}
      />
    );
  },
);
